import React, { Component } from 'react'

export default class BoxSection extends Component {
	render() {
        const { title, actions, children } = this.props
		return (
            <div className="section-area" style={{ marginTop: 0 }}>
                <div className="section-area-header">
                    <h4 className="section-area-title">{ title }</h4>
                    <div>
                        { actions }
                    </div>
                </div>
                { children }
            </div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/Layout/BoxSection.jsx